import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom, Observable} from 'rxjs';
import {BasedataService} from '../../shared/basedata.service';
import {BimSection} from './bim-section.interface';
import {CreateBimSectionDto, SectionPlan, UpdateBimSectionDto} from './bim-section.dto';
import { BpConfigService } from '../../config/bp-config.service';

@Injectable({providedIn: 'root'})
export class BimSectionApiService extends BasedataService {
  endpoint: string;
  baseEndpoint: string;

  constructor(private http: HttpClient, configService: BpConfigService) {
    super(configService);
    this.endpoint = super.getFullUrl('bim-models');
    this.baseEndpoint = super.getFullUrl('');
  }

  getAllBimSections(): Observable<BimSection[]> {
    const url = `${this.baseEndpoint}/floor-plans`;
    return this.http.get<BimSection[]>(url);
  }

  getBimSections(modelId: string): Observable<BimSection[]> {
    const url = `${this.endpoint}/${modelId}/floor-plans`;
    return this.http.get<BimSection[]>(url);
  }

  createBimSection(modelId: string, bimSection: CreateBimSectionDto): Observable<BimSection> {
    const url = `${this.endpoint}/${modelId}/floor-plans`;
    return this.http.post<BimSection>(url, bimSection);
  }

  updateBimSection(modelId: string, sectionId: string, bimSection: UpdateBimSectionDto): Observable<BimSection> {
    const url = `${this.endpoint}/${modelId}/floor-plans/${sectionId}`;
    return this.http.patch<BimSection>(url, bimSection);
  }

  updateBimSectionPlan(modelId: string, sectionId: string, planData: SectionPlan): Observable<BimSection> {
    const url = `${this.endpoint}/${modelId}/floor-plans/${sectionId}/plan`;
    return this.http.patch<BimSection>(url, planData);
  }

  public uploadFloorPlan(modelId: string, floorPlanId: string, file: Blob): Promise<BimSection> {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${this.endpoint}/${modelId}/floor-plans/${floorPlanId}/upload`;
    return lastValueFrom(this.http.post<BimSection>(url, formData));
  }

  public deleteBimSectionPlan(modelId: string, floorPlanId: string, planId: string, versionId: string): Observable<BimSection> {
    const url = `${this.endpoint}/${modelId}/floor-plans/${floorPlanId}/plan`;
    const data = {
      'planId': planId,
      'versionId': versionId
    }
    return this.http.delete<BimSection>(url, { body: data });
  }

  public deleteBimSection(modelId: string, floorPlanId: string): Observable<BimSection> {
    const url = `${this.endpoint}/${modelId}/floor-plans/${floorPlanId}`;
    return this.http.delete<BimSection>(url);
  }

}
